import { GovernmentIssuedWcJurisdictions } from '@evidentid/tprm-portal-lib/models/common';
import { EntityAddress } from '@evidentid/tprm-portal-lib/models/dashboard';

/**
 * Whether the address is in a jurisdiction where workers compensation is government-issued, so the
 * entity obtains the policy itself rather than through a producer.
 *
 * The jurisdictions come from eid-insurance, which routes notifications on the same list. An absent
 * address is "not government-issued". So are absent jurisdictions, but only because the function has
 * to return something: it cannot know, and a caller that acts on WC ownership must wait for the list
 * instead, as the producers card does.
 *
 * The state field is free text, so it is normalized the way eid-insurance normalizes it before matching.
 * The two agree for ordinary spaces; JavaScript also strips a non-breaking space, which eid-insurance keeps.
 */
export function isGovernmentIssuedWcLocation(
    address: Partial<EntityAddress> | null | undefined,
    jurisdictions: GovernmentIssuedWcJurisdictions | null | undefined,
): boolean {
    if (!jurisdictions) {
        return false;
    }
    const country = (address?.country ?? '').trim().toUpperCase();
    const state = (address?.state ?? '').trim().replace(/\s+/g, ' ').toUpperCase();
    return jurisdictions.countries.includes(country) || jurisdictions.states.includes(state);
}
